import { useMemo } from 'react';
import { UNITE_TRANSCRIPTION_AND_AUDIO_PLAYBACK } from '@rsos/capstone/src/constants/capabilities';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';
import { UNITE_TRANSCRIPTION_AND_AUDIO_PLAYBACK_PERMISSION } from '../constants/permissions';

const useHasAccessToTranscriptAndAudioPlayback = () => {
  const hasUnitedTranscriptionAndAudioPlaybackCapabilities = useHasCapability(
    UNITE_TRANSCRIPTION_AND_AUDIO_PLAYBACK,
  );
  const hasUniteTranscriptionAndAudioPlaybackPermission = useHasPermission(
    UNITE_TRANSCRIPTION_AND_AUDIO_PLAYBACK_PERMISSION,
  );
  const hasAccessToTranscriptionAndAudioPlaybackFeature = useMemo(() => {
    return (
      !!hasUnitedTranscriptionAndAudioPlaybackCapabilities?.hasCapability &&
      !!hasUniteTranscriptionAndAudioPlaybackPermission?.hasPermission
    );
  }, [
    hasUnitedTranscriptionAndAudioPlaybackCapabilities,
    hasUniteTranscriptionAndAudioPlaybackPermission,
  ]);

  return hasAccessToTranscriptionAndAudioPlaybackFeature;
};

export default useHasAccessToTranscriptAndAudioPlayback;
